<template>
    <div style="position:relative;">
        <button
            @click="toggleLanguage"
            class="language-button"
            aria-label="Toggle Language"
            @mouseenter="showTooltipAt($event)"
            @mousemove="showTooltipAt($event)"
            @mouseleave="showTooltip = false"
        >
            {{ toggleLabel }}
        </button>
        <span
            v-if="showTooltip"
            class="custom-tooltip"
            :style="{ left: tooltipX + 'px', top: tooltipY + 'px' }"
        >
            {{ tooltip }}
        </span>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const showTooltip = ref(false)
const tooltipX = ref(0)
const tooltipY = ref(0)

const showTooltipAt = (event) => {
    showTooltip.value = true
    const parentRect = event.currentTarget.parentElement.getBoundingClientRect()
    tooltipX.value = event.clientX - parentRect.left -310
    tooltipY.value = event.clientY - parentRect.top + 20
}

const toggleLanguage = () => {
    const newLocale = locale.value === 'en' ? 'de' : 'en'
    setLanguage(newLocale)
}

const setLanguage = (lang) => {
    localStorage.setItem('locale', lang)
    locale.value = lang
}

onMounted(() => {
    const initLanguage = localStorage.getItem('locale') || 'en'
    setLanguage(initLanguage)
})

const toggleLabel = computed(() => (locale.value === 'en' ? 'EN' : 'DE'))
const tooltip = computed(() => (locale.value === 'en' ? 'Switch to German (needs Page reload F5)' : 'Umschalten zu Englisch (Seite neu laden F5)'))
</script>

<style scoped>
.language-button {
    position: fixed;
    font-size: large;
    color: var(--text-primary-color);
    top: calc(1rem + 40px);
    right: 1rem;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 999;
    padding: 0;
}
.custom-tooltip {
    position: absolute;
    background: var(--tooltip-bg, #222);
    color: var(--tooltip-text, #fff);
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 0.95em;
    white-space: nowrap;
    z-index: 1000;
    pointer-events: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    border: 1px solid var(--tooltip-border, #444);
    transition: background 0.2s, color 0.2s;
}
</style>